import React from "react"
import {
  SensaiComponentZonesContentZone,
  SensaiContentSectionsSectionsDynamicZone,
  Sensaienum_Contentsections_Backgroundcolor,
} from "../../gql/generated/graphql"
import { Box } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import PaddedContainer from "../ui/PaddedContainer"
import CalloutCard from "./content-items/CalloutCard"
import CalloutCardHorizontal from "./content-items/CalloutCardHorizontal"
import BoxedTextCard from "./content-items/BoxedTextCard"
import LinkoutCard from "./content-items/LinkoutCard"
import ImageCard from "./content-items/ImageCard"
import SimpleText from "./content-items/SimpleText"
import ImageContainedCard from "./content-items/ImageContainedCard"
import PriceText from "./content-items/PriceText"
import PriceCard from "./content-items/PriceCard"

const getContent = (
  card: SensaiContentSectionsSectionsDynamicZone,
  columnSize: number,
  size: number,
  backgroundColor?: Sensaienum_Contentsections_Backgroundcolor
) => {
  const horizontal = columnSize >= 12
  switch (card.__typename) {
    case "SENSAIComponentCardsCallout":
      return horizontal ? (
        <CalloutCardHorizontal card={card} />
      ) : (
        <CalloutCard card={card} />
      )
    case "SENSAIComponentCardsBoxedText":
      return <BoxedTextCard card={card} />
    case "SENSAIComponentCardsLinkout":
      return <LinkoutCard card={card} />
    case "SENSAIComponentCardsImage":
      return <ImageCard card={card} size={columnSize >= 6 ? "md" : "sm"} />
    case "SENSAIComponentCardsImageContained":
      return <ImageContainedCard card={card} />
    case "SENSAIComponentCardsSpacer":
      return <Box />
    case "SENSAIComponentTextSimpleText":
      return <SimpleText card={card} />
    case "SENSAIComponentTextPrice":
      return (
        <PriceText card={card} backgroundColor={backgroundColor} size={size} />
      )
    case "SENSAIComponentCardsPrice":
      return <PriceCard card={card} />
    default:
      return <Box>{card.__typename}</Box>
  }
}

const ContentZone = (section: SensaiComponentZonesContentZone) => {
  const {
    sections,
    sectionHeading,
    columns,
    verticalAlignment,
    backgroundColor,
  } = section.section ?? {}
  const columnSize = Math.floor(12 / (columns ?? 1))

  return (
    <PaddedContainer>
      {sectionHeading && (
        <Box sx={{ textAlign: "center", margin: "0 auto" }}>
          <Typography
            variant="h2"
            color="textSecondary"
            className="gradientText"
            fontSize={"2.5rem"}
            fontWeight={600}
            marginBottom={"2rem"}
          >
            {sectionHeading}
          </Typography>
        </Box>
      )}
      <Grid
        container
        spacing={
          (sections?.length ?? 0) >= 5
            ? 3
            : (sections?.length ?? 0) === 4
            ? 4
            : 5
        }
        alignItems={verticalAlignment === "top" ? "start" : "stretch"}
        justifyContent={"center"}
      >
        {sections &&
          sections?.map(s => {
            if (!s) {
              return <></>
            }

            const columnSpan =
              (s as any).cardStyle?.columnSpan ?? (s as any).columnSpan ?? 1
            const size = columnSize * columnSpan
            return (
              <Grid
                item
                xs={12}
                sm={
                  columnSize == 4
                    ? 6 * columnSpan
                    : columnSize <= 3
                    ? size * 2
                    : size
                }
                md={columnSize <= 3 ? size * 2 : size}
                lg={size}
                style={{ display: "flex" }}
              >
                {getContent(s, columnSize, size, backgroundColor as any)}
              </Grid>
            )
          })}
      </Grid>
    </PaddedContainer>
  )
}

export default ContentZone
